export const TABS = {
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
};

export const TAB_NAMES = {
  [TABS.ACTIVE]: 'Active',
  [TABS.FAILED]: 'Failed',
  [TABS.COMPLETE]: 'Executed Actions',
};
